// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2D1U-","productName":"Table_productName__3-3Sh"};